import React, {useContext, useReducer} from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import { unregister } from './registerServiceWorker';

import axios from 'axios';

import Nationality from './models/Nationality';
import FormService from './services/formService';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
//const initialState = window.initialReduxState;
//const store = configureStore(history, initialState);

//NOTE : Fix IE Edge issue 
// https://github.com/facebook/create-react-app/pull/8116/commits/fb46da2d69e8090391151f00f7563182caec59b7
//C:\dev\intuition\ClientApp\node_modules\react-dev-utils


const rootElement = document.getElementById("root");

const loadStaticData = async() => {
  alert("Load static data")
  const response = await axios.get<Array<Nationality>>("/api/StaticData/GetAllNationalities");
  FormService.setNationalityList(response.data);
}


ReactDOM.render(
    <Router > 
      <App />
    </Router>
  ,rootElement
);

unregister();


//loadStaticData();
